// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'bootstrap'
import 'vue-awesome/icons/spinner'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import store from './vuex/store'
import VueRouter from 'vue-router'
import Vuelidate from 'vuelidate'
import VueI18n from 'vue-i18n'
import VueMoment from 'vue-moment'
import VueAnalytics from 'vue-analytics'
import Icon from 'vue-awesome/components/Icon'
import Toasted from 'vue-toasted'
import { routes } from './routes'
import * as filters from './util/filters'
import Modal from './plugins/modal'
import { modals } from './modals'
import { shim } from 'promise.prototype.finally'

shim()

Vue.config.productionTip = false
Vue.use(VueMoment)
Vue.use(VueRouter)
Vue.use(Vuelidate)
Vue.use(VueI18n)
Vue.use(BootstrapVue)
Vue.component('icon', Icon)
Vue.use(Toasted, {
  position: 'top-center',
  duration: 3000
})
Vue.use(Modal, {
  modals: modals,
  onOpen (modal) {
    if (modal === 'cart-dropdown') return
    document.body.classList.add('modal-open')
  },
  onClose () {
    document.body.classList.remove('modal-open')
  }
})

const i18n = new VueI18n({
  locale: store.state.language.lang,
  messages: {
    en: {
    }
  }
})

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

var analyticsOption = {
  id: 'UA-52876762-9',
  router,
  debug: {
    sendHitTask: (function () {
      var enable = false
      if (window.location.host === 'bento.halal-navi.com') {
        if (document.cookie.indexOf('debug=true') === -1) {
          enable = true
        }
      }
      console.log('ga:', enable)
      return enable
    })()
  }
}

if (store.state.user.profile) {
  analyticsOption['set'] = [
    {field: 'userId', value: store.state.user.profile.hn_id.toString()}
  ]
}

Vue.use(VueAnalytics, analyticsOption)

window.bentoApp = new Vue({
  el: '#app',
  store,
  router,
  i18n,
  ...App
})



// WEBPACK FOOTER //
// ./src/main.js